<template>
  <div class="container">
    <div class="row bottom full-height">
      <div class="col-md-3 col-sm-3 full-height sidebar hidden-xs  content border-left-1-neutral-1 ">
        <Sidebar/>
      </div>
      <div class="col-md-9 col-sm-9 full-height col-xs-12 content border-left-1-neutral-1 border-right-1-neutral-1">
        <AppBarItem/>
        <div class="loader__container" v-if="isLoading">
          <div class="loader"></div>
        </div>
        <transition :name="transitionClassName">
          <router-view class="child-view" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/SideBar'
import AppBarItem from './components/AppBarItem'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  components: { Sidebar, AppBarItem },
  data() {
    return {
      transitionClassName: "out-left"
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
    }),
  },
  watch: {
    '$route'(to, from) {
      if (to.name == "Practices" && from.name == "PetOwnerDetails") {
        this.transitionClassName = "out-right"
      }
      else if (to.name == "PetOwnerDetails" && from.name == "PetList") {
        this.transitionClassName = "out-right"
      }
      else if (to.name == "PetOwnerDetails" && from.name == "NewPet") {
        this.transitionClassName = "out-right"
      }
      else if (to.name == "NewPet" && from.name == "PetServices") {
        this.transitionClassName = "out-right"
      }
      else if (to.name == "PetList" && from.name == "PetServices") {
        this.transitionClassName = "out-right"
      }
      else if (to.name == "PetServices" && from.name == "AppointmentCalendar") {
        this.transitionClassName = "out-right"
      }
      else if (to.name == "AppointmentCalendar" && from.name == "ConfirmationPrompt") {
        this.transitionClassName = "out-right"
      }
      else {
        this.transitionClassName = "out-left"
      }
    }
  }
}
</script>

<style src="./assets/colors.scss" lang="scss"></style>
<style src="./assets/margin.scss" lang="scss"></style>
<style src="./assets/padding.scss" lang="scss"></style>
<style src="./assets/main.scss" lang="scss"></style>

<style>
  .bottom{
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue